
interface Props {
    characterId: string;
    onToast: (ability: string) => void;
}

// Mock Abilities
const MOCK_ABILITIES = [
    { id: 'neutral-b', name: 'PK Flash', icon: '⚡' },
    { id: 'side-b', name: 'PK Fire', icon: '🔥' },
    { id: 'up-b', name: 'PK Thunder', icon: '⛈️' },
    { id: 'down-b', name: 'PSI Magnet', icon: '🧲' },
    { id: 'fs', name: 'PK Starstorm', icon: '🌠' },
];

export function AbilityToaster({ onToast }: Props) {
    return (
        <div className="grid grid-cols-2 gap-3 h-full">
            {MOCK_ABILITIES.map((abil) => (
                <button
                    key={abil.id}
                    onClick={() => onToast(abil.name)}
                    className="
             relative group overflow-hidden
             bg-slate-800 hover:bg-slate-700 active:bg-sky-600
             border-2 border-slate-700 hover:border-sky-400
             rounded-xl p-4 flex flex-col items-center justify-center gap-2
             transition-all duration-100 active:scale-95 touch-manipulation
             h-24 md:h-auto
           "
                >
                    <div className="text-3xl group-active:scale-125 transition-transform">{abil.icon}</div>
                    <span className="font-bold text-slate-300 group-hover:text-white text-sm uppercase tracking-wide">{abil.name}</span>

                    {/* Ripple Effect / Flash on click would go here */}
                </button>
            ))}
        </div>
    );
}
